if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = Backbone.View.extend({
  initialize: function() {
    _.bindAll(this, 'render');
    this.model.bind('change:disabled', this.render);
    if (VariationsWidget.printSoldOut) {
      this.model.bind('change:forceDisplay', this.render);
    }
    if (VariationsWidget.printOptionPrice) {
      this.model.bind('change:optionPrice', this.render);
      this.model.bind('change:selected', this.render);
    }
    return this.rtl = $('body').hasClass('rtl');
  },
  render: function() {
    this.$el.attr('disabled', this.model.get('disabled'));
    this.clearSoldOut();
    if (VariationsWidget.printSoldOut && this.model.get('disabled')) {
      this.renderSoldOut();
    }
    if (VariationsWidget.printOptionPrice) {
      return this.renderPrintOptionPrice();
    }
  },
  clearSoldOut: function() {
    this.$el.removeClass('force-display');
    this.$el.find('.sold-out-text').remove();
  },
  renderSoldOut: function() {
    var soldOutText, string;
    if (!this.model.get('forceDisplay')) {
      return;
    }
    soldOutText = typeof I18n !== "undefined" && I18n !== null ? I18n.t('js.modules.variations.sold_out') : void 0;
    string = "<span class=\"sold-out-text\">" + soldOutText + "</span>";
    this.$el.addClass('force-display');
    if (this.rtl) {
      this.$el.append(string);
    } else {
      this.$el.prepend(string);
    }
  },
  renderPrintOptionPrice: function() {
    var isSelected, optionPrice, string;
    optionPrice = this.model.get('optionPrice');
    isSelected = this.model.get('selected');
    string = "<span class=\"option-price\">(" + optionPrice + ")</span>";
    this.$el.find('.option-price').remove();
    if (optionPrice && !isSelected) {
      if (this.rtl) {
        return this.$el.prepend(string);
      } else {
        return this.$el.append(string);
      }
    }
  }
});

module.exports = VariationsWidget.Views.Option;

//# sourceMappingURL=data:application/json;base64,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
